/* InstallableAppAlreadyInstalledMessage.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodySmall } from '@atlassian/mpac-primitives';
import capitalize from 'lodash/capitalize';
import React from 'react';
import InstallableAppCenterFooter, { BoldHeader } from './InstallableAppCenterFooter';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _6 = "._p12fxwrn{max-width:18.25rem}";
const _5 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _4 = "._y3gn1h6o{text-align:center}";
const _3 = "._1bah1h6o{justify-content:center}";
const _2 = "._4cvr1h6o{align-items:center}";
const _ = "._1e0c1txw{display:flex}";
const editionAlreadyAddedContainer = null;
const editionAlreadyAddedText = null;
const InstallableAppAlreadyInstalledMessage = props => {
  var _props$installedApp, _props$installedApp$g;
  const {
    enableSelfServeAppEditions
  } = useStatsig();
  const installedEdition = (_props$installedApp = props.installedApp) === null || _props$installedApp === void 0 ? void 0 : (_props$installedApp$g = _props$installedApp.getOrElse(null)) === null || _props$installedApp$g === void 0 ? void 0 : _props$installedApp$g.get('edition', null);
  if (enableSelfServeAppEditions() && Boolean(installedEdition)) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_1e0c1txw _4cvr1h6o _1bah1h6o"]),
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_4, _5, _6]
          }), /*#__PURE__*/_jsxs(BodySmall, {
            className: ax(["_y3gn1h6o _syaz1fxt _p12fxwrn"]),
            children: ["The ", capitalize(installedEdition), " plan of this app has already been added to your instance"]
          })]
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(InstallableAppCenterFooter, {
    children: [/*#__PURE__*/_jsx(BoldHeader, {
      children: "We're seeing double!"
    }), /*#__PURE__*/_jsxs("div", {
      children: ["This app is already added to ", props.hostConfig.installationLocation, "."]
    })]
  });
};
export default InstallableAppAlreadyInstalledMessage;